/* jshint esversion: 6 */
import { of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    SocialLoginActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchSocialLoginsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_LOGIN_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => {
        let state = state$.value;
        // Short circuit pulls of the main list --- CRUD operations will work on the state
        // so in theory we only need to pull the main list once
        // TODO: determine if we need an expiration
        if (state.socialLogins.length) {
            return of(SocialLoginActions.receiveSocialLogins(state.socialLogins));
        } else {
            return api(action.type, state$, null, null, SocialLoginActions.receiveSocialLogins);
        }

    })
);

export const deleteSocialLoginEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_LOGIN_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SocialLoginActions.deletedSocialLogin))
);

export const createSocialLoginEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SOCIAL_LOGIN_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SocialLoginActions.createdSocialLogin))
);
